import {createAsyncThunk} from '@reduxjs/toolkit';
import {
  admissionsAdvisorService,
} from '../services/admissions-advisor-services';
import {patientHelper} from '../../patient/services/patient-service';
import {
  EstLevelOfCare,
} from '../models/estimator';
import {Estimate, Id} from "@finpay-estimation/estimation-types"
import {admissionsAdvisorUtils} from '../utils/admission-advisor-utils';
import {showErrorStatus} from '../../security/state/user-slice';
import {estimateConfig} from '../components/pfr-estimator/estimator-footer';

export const getClientLevelsOfCare = createAsyncThunk(
  "estimatorContext/getClientLevelsOfCare",
  async (params: any, thunkAPI) => {
    const response = await admissionsAdvisorService.getClientLevelsOfCare(params.paramId, params.clientId);
    if (response.hasErrors) {
      patientHelper.robustErrorHandler(response, thunkAPI);
    } else {
      let clientLevelsOfCare: EstLevelOfCare[] = [];
      // filter data by payerPlanId
      if (params.filterByPayerPlanId) {
        clientLevelsOfCare = admissionsAdvisorUtils.filterLevelsOfCareByPayerPlanId(response?.entity, params.payerPlanId)
      } else {
        if (params.payerPlanId) {
          clientLevelsOfCare = admissionsAdvisorUtils.filterPayorLocRateLosByPayerPlanId(response?.entity, params.payerPlanId)
        } else {
          clientLevelsOfCare = response?.entity;
        }
        
      }

      if(clientLevelsOfCare.length ===0){
        const errorMessage = "There are no client levels of care to show. Please contact a system administrator."
        thunkAPI.dispatch(showErrorStatus(errorMessage));
        throw new Error(errorMessage);
      }

      let responseBody = {
        facilityLevelsOfCare: clientLevelsOfCare,
        masterListLevelsOfCare: params.masterListLevelsOfCare
      };

      return admissionsAdvisorUtils.fillClientFacilityDataGaps(responseBody) as EstLevelOfCare[];
    }
  }
);

export const getClientDetails = createAsyncThunk(
  "estimatorContext/getClientDetails",
  async (config: any, thunkAPI) => {
    const response = await admissionsAdvisorService.getClientDetails(config.paramId, config.clientId);
    if (response.hasErrors) {
      patientHelper.robustErrorHandler(response, thunkAPI);
    } else {
      return response.entity;
    }
  }
);


export const getSavedEstimates = createAsyncThunk(
  "estimatorContext/getSavedEstimates",
  async (config: estimateConfig, thunkAPI) => {

    const response = await admissionsAdvisorService.getEstimations({
      paramId: config.paramId,
      queryStringParams: {
        vobId : config.vobId
      }
    });

    if (response.hasErrors) {
      patientHelper.robustErrorHandler(response, thunkAPI);
    }

    return response.entity

  }
);

export const callNewEstimatePost = createAsyncThunk(
  'estimatorContext/callNewEstimatePost',
  async (estimate: Estimate, thunkAPI) => {
    const response = await admissionsAdvisorService.callNewEstimatePost(estimate)

    if (response.hasErrors) {
      patientHelper.robustErrorHandler({entity: {code: "", message: "Failed to create estimate. Please contact FinPay Support"}, errorMessage: "Failed to create estimate. Please contact FinPay Support", hasErrors: true}, thunkAPI);
    }

    return response.entity;
  }
)

export const callNewEstimatePut = createAsyncThunk(
  'estimatorContext/callNewEstimatePut',
  async (config: {estimate: Estimate, estimateId: Id | undefined}, thunkAPI) => {
    const response = await admissionsAdvisorService.callNewEstimatePut(config.estimate, config.estimateId)

    if (response.hasErrors) {
      patientHelper.robustErrorHandler({entity: {code: "", message: "Failed to update estimate. Please contact FinPay Support"}, errorMessage: "Failed to update estimate. Please contact FinPay Support", hasErrors: true}, thunkAPI);
    }

    return response.entity;
  }  
)

export const callNewEstimateGet = createAsyncThunk(
    'estimatorContext/callNewEstimateGet',
    async (config: any, thunkAPI) => {
        const response = await admissionsAdvisorService.callNewEstimateGet(
            config.paramId,
            config.estimationId
        );
        if (response.hasErrors) {
            patientHelper.robustErrorHandler(response, thunkAPI);
        } else {
            return response.entity;
        }
    }
);

export const getNewFacilityLevelsOfCare = createAsyncThunk(
  'estimatorContext/getFacilityLevelsOfCare',
  async (config: any, thunkAPI) => {
    const response = await admissionsAdvisorService.getFacilityLevelsOfCare(config.facilityId, config.facilityPayorPlanId);
    if (response.hasErrors) {
      patientHelper.robustErrorHandler({entity: {code: "INTERNAL_SERVER_ERROR", message: "Data Rate is Missing for Facility Selected. Please contact FinPay Support"}, errorMessage: "Data Rate is Missing for Facility Selected. Please contact FinPay Support", hasErrors: true}, thunkAPI);
    } else {
      return response.entity;
    }
  }
)

